// extracted by mini-css-extract-plugin
export default {"title":"Quote_title__JNWAg","edit":"Quote_edit__XNROR","total":"Quote_total__mohRJ"};